/**
 * THE TWO FIELDS ONLY THE MOVE FLOW DRAWS: a card with a radio for each answer to "how will she
 * know", and a time box.
 */

export function HowChoice({
  id,
  checked,
  onChoose,
  label,
  detail,
}: {
  id: string;
  checked: boolean;
  onChoose: () => void;
  label: string;
  detail: string;
}) {
  return (
    <label
      htmlFor={id}
      className={`flex min-h-12 desk:min-h-9 cursor-pointer items-start gap-3 rounded-lg border p-3 ${
        checked ? 'border-navy bg-gold/10' : 'border-navy/25'
      }`}
    >
      <input
        id={id}
        type="radio"
        name="how"
        checked={checked}
        onChange={onChoose}
        className="mt-1 h-5 w-5 shrink-0 accent-navy"
      />
      <span>
        <span className="block text-sm font-medium">{label}</span>
        <span className="block text-xs text-navy/65">{detail}</span>
      </span>
    </label>
  );
}

/** An `<input type="time">`, which hands back HH:MM, the shape the API takes. */
export function TimeField({
  id,
  label,
  value,
  onChange,
}: {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="mb-4">
      <label htmlFor={id} className="block text-sm font-medium">
        {label}
      </label>
      <input
        id={id}
        type="time"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="mt-1 block min-h-11 desk:min-h-9 w-full rounded-lg border border-navy/25 bg-parchment px-3 py-2 text-navy"
      />
    </div>
  );
}
